import { render, staticRenderFns } from "./HistoryOrderPage.vue?vue&type=template&id=1fced3bd&scoped=true"
import script from "./HistoryOrderPage.vue?vue&type=script&lang=js"
export * from "./HistoryOrderPage.vue?vue&type=script&lang=js"
import style0 from "./HistoryOrderPage.vue?vue&type=style&index=0&id=1fced3bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fced3bd",
  null
  
)

export default component.exports